import React from 'react';
import goatMark from '../../shared/goatMark';

// The MixGoat mark for design v2: a single-path goat head (Erez's vector,
// 2026-10-22), filled with the accent token so it follows the theme. Classic
// keeps the headphone goat in MixGoatLogo.js.

export const { GOAT_MARK_VIEWBOX, GOAT_MARK_PATH } = goatMark;

// Small optical size: a hairline in the page colour along the path's edges
// opens the horn gap and the eye cutouts and thins the tuft, the way a type
// designer cuts a small size. 14 units at the 32px rail, 22 at favicon size,
// nothing at 48 and above where the drawing stands on its own.
const compensation = (size) => (size <= 20 ? 22 : size <= 40 ? 14 : 0);

const GoatMark = ({ size = 32, className, title }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox={GOAT_MARK_VIEWBOX}
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        role={title ? 'img' : undefined}
        aria-hidden={title ? undefined : true}
        style={{ color: 'var(--color-accent)' }}
    >
        {title ? <title>{title}</title> : null}
        <path fillRule="evenodd" d={GOAT_MARK_PATH} stroke={compensation(size) ? 'var(--v2-page)' : undefined} strokeWidth={compensation(size) || undefined} strokeLinejoin="round" />
    </svg>
);

export default GoatMark;
